import React from "react";
import {
  Container,
  Title,
  ImageContainer,
  InnerContainer,
  TextContainer,
} from "./MediaPartner.styled";
import { func } from "../../../utils";
import useWindowSize from "../../../hooks/useWindowSize";
import { getStaticImg } from "../../../utils/function";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

// Fix: Rename component to MediaPartner to match export
const MediaPartner = ({
  title,
  contents,
  titleClassName = "",
  isInline = false,
}) => {
  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 768;

  const handleClick = (val) => {
    if (val?.content_url) {
      return window.open(val.content_url, "_blank");
    } else return false;
  };

  return (
    <>
      {/* Add class for inline display */}
      <Container className={isInline ? "inline-container" : ""}>
        <img
          id="title-img"
          className="mx-auto z-20 lg:max-w-[428px] lg:h-[55px]"
          style={{
            // maxWidth: "428px",
            height: "55px",
            objectFit: "contain",
            objectPosition: "center",
          }}
          src={getStaticImg("illustration/media-partner-title.png")}
          alt={title || "Media Partner"}
        />

        {/* Add class for inline display */}
        <InnerContainer
          numItems={contents?.length}
          className={isInline ? "inline-items" : ""}
        >
          {contents?.map((value, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                flexDirection: "column",
                borderRadius: 24,
                marginBottom: idx === contents?.length - 1 ? "24px" : "auto",
                cursor: value?.content_url?.length ? "pointer" : "default",
              }}
              onClick={() => handleClick(value)}
            >
              <ImageContainer
                key={idx}
                cursor={value?.content_url?.length ? "pointer" : "default"}
                // Add class for inline display
                className={isInline ? "inline-image" : ""}
              >
                {/* Fix the template literal issue in className */}
                <img
                  src={imgPath + value?.key_visual}
                  className={`object-contain z-20 ${
                    isMobileView
                      ? "w-auto"
                      : isInline
                      ? "max-w-[150px]" // Smaller images when inline
                      : contents?.length > 1
                      ? "lg:w-[170px]"
                      : "w-auto"
                  }`}
                  style={{
                    maxHeight: isInline ? "90px" : "auto", // Control height when inline
                  }}
                />
              </ImageContainer>
            </div>
          ))}
        </InnerContainer>
      </Container>
    </>
  );
};

// Fix: Export MediaPartner instead of Sponsor
export default MediaPartner;
